import { connect } from 'react-redux'
import BillingAccountLinkStep from './BillingAccountLinkStep'

const stateToProps = (undefined, props) => ({
  loading: props.loading || props.formData?.isLoading || false,
})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(BillingAccountLinkStep)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountLinkStep/BillingAccountLinkStep.container.js